import {
  PIPEFITTER_PROJECT_LOADER_START,
  PIPEFITTER_PROJECT_LOADER_STOP,
  PIPEFITTER_SET_PROJECT_LIST,
  PIPEFITTER_SET_SELECTED_PROJECT,
  PIPEFITTER_SET_PIPE_COUNT,
  PIPEFITTER_SET_TOTAL_PIPE_COUNT,
  PIPEFITTER_SET_USED_PIPE_COUNT,
  PIPEFITTER_SET_SPREAD_PIPE_COUNT,
  PIPEFITTER_SET_SUBSPREAD_PIPE_COUNT,
  PIPEFITTER_SET_MEAN_MAX_CALCULATION_STATUS,
  PIPEFITTER_SET_CONFIGURATION_LOADING,
  PIPEFITTER_SET_CONFIGURATION_LIST,
  PIPEFITTER_CREATE_SPREAD_CONFIGURATION,
  PIPEFITTER_UPDATE_SPREAD_CONFIGURATION,
  PIPEFITTER_DELETE_SPREAD_CONFIGURATION,
  PIPEFITTER_CREATE_SUB_SPREAD_CONFIGURATION,
  PIPEFITTER_UPDATE_SUB_SPREAD_CONFIGURATION,
  PIPEFITTER_DELETE_SUB_SPREAD_CONFIGURATION,
  PIPEFITTER_SORT_SPREAD_CONFIGURATION,
  PIPEFITTER_SORT_SUB_SPREAD_CONFIGURATION,
  PIPEFITTER_FETCH_SEQUENCE_CONFIGURATION_LIST,
  PIPEFITTER_GENERATE_SEQUENCE_CONFIGURATION_LIST,
  PIPEFITTER_PIPE_BASED_GENERATE_SEQUENCE,
  PIPEFITTER_UPDATE_SPREAD_NAME,
  PIPEFITTER_DELETE_SEQUENCE_SPREAD,
  PIPEFITTER_FETCH_SEQUENCE_REPORT,
  PIPEFITTER_APPROVE_SEQUENCE_SPREAD,
  PIPEFITTER_SEND_EMAIL_SEQUENCE,
  PIPEFITTER_MIN_MAX_CALCULATION,
  PIPEFITTER_SET_SEQUENCE_LIST,
  PIPEFITTER_SET_SEQUENCE_LOADING,
  PIPEFITTER_SET_SEQUENCE_LOADING_MORE,
  PIPEFITTER_SET_REPORTS_LOADING,
  PIPEFITTER_FETCH_PIPE_DATA_GRAPH,
  PIPEFITTER_FETCH_PROJECT_STATUS_PIPE_DATA,
  PIPEFITTER_FETCH_PROJECT_REPORT,
  PIPEFITTER_FETCH_PROJECT_SUMMARY_REPORT,
  PIPEFITTER_SEND_EMAIL_PIPE_DATA,
  PIPEFITTER_SEND_EMAIL_PROJECT_SUMMARY,
  PIPEFITTER_ASSIGN_PIPE_STATUS_DATA,
  PIPEFITTER_CREATE_UPDATE_PIPE_DATA,
  PIPEFITTER_DELETE_PIPE_DATA,
  PIPEFITTER_UPDATE_PIPE_STATUS,
  PIPEFITTER_GENERATE_REPORT_PIPE_DATA,
  PIPEFITTER_GENERATE_REPORT_PIPE_DATA_PIPEWISE,
  PIPEFITTER_GENERATE_REPORT_PROJECT_SUMMARY,
  PIPEFITTER_TRIGGER_REPORT_COMPLIMENTARY,
  PIPEFITTER_SET_PIPE_STATISTICS,
  PIPEFITTER_SET_PIPE_STATUS,
  PIPEFITTER_SET_PIPE_STATUS_PAGINATION,
  PIPEFITTER_SET_PIPE_STATUS_LOADING_MORE,
  PIPEFITTER_SET_PIPE_DATA_GRAPH,
  PIPEFITTER_SET_PROJECT_STATUS_PIPE_DATA,
  PIPEFITTER_SET_PROJECT_SUMMARY_DATA,
  PIPEFITTER_SET_PIPES_LIST_FILTERED,
  PIPEFITTER_SET_INVALID_FILES,
  PIPEFITTER_UPLOAD_JSON_FILES,
  PIPEFITTER_RANDOM_COMPAT_SUBMIT,
  PIPEFITTER_RANDOM_COMPAT_RESET,
  PIPEFITTER_RANDOM_COMPAT_SET_STATE,
} from './types';

// Project
export const pipefitterStartProjectLoader = () => ({ type: PIPEFITTER_PROJECT_LOADER_START });
export const pipefitterStopProjectLoader = () => ({ type: PIPEFITTER_PROJECT_LOADER_STOP });
export const pipefitterSetProjectList = (payload) => ({ type: PIPEFITTER_SET_PROJECT_LIST, payload });
export const pipefitterSetSelectedProject = (payload) => ({ type: PIPEFITTER_SET_SELECTED_PROJECT, payload });
export const pipefitterSetPipeCount = (payload) => ({ type: PIPEFITTER_SET_PIPE_COUNT, payload });
export const pipefitterSetTotalPipeCount = (payload) => ({ type: PIPEFITTER_SET_TOTAL_PIPE_COUNT, payload });
export const pipefitterSetUsedPipeCount = (payload) => ({ type: PIPEFITTER_SET_USED_PIPE_COUNT, payload });
export const pipefitterSetSpreadPipeCount = (payload) => ({ type: PIPEFITTER_SET_SPREAD_PIPE_COUNT, payload });
export const pipefitterSetSubSpreadPipeCount = (payload) => ({ type: PIPEFITTER_SET_SUBSPREAD_PIPE_COUNT, payload });
export const pipefitterSetMeanMaxCalculationStatus = (payload) => ({
  type: PIPEFITTER_SET_MEAN_MAX_CALCULATION_STATUS,
  payload,
});

// Configuration
export const pipefitterSetConfigurationLoading = (payload) => ({ type: PIPEFITTER_SET_CONFIGURATION_LOADING, payload });
export const pipefitterSetConfigurationList = (payload) => ({ type: PIPEFITTER_SET_CONFIGURATION_LIST, payload });
export const pipefitterCreateSpreadConfiguration = (payload) => ({ type: PIPEFITTER_CREATE_SPREAD_CONFIGURATION, payload });
export const pipefitterUpdateSpreadConfiguration = (payload) => ({ type: PIPEFITTER_UPDATE_SPREAD_CONFIGURATION, payload });
export const pipefitterDeleteSpreadConfiguration = (payload) => ({ type: PIPEFITTER_DELETE_SPREAD_CONFIGURATION, payload });
export const pipefitterCreateSubSpreadConfiguration = (payload) => ({ type: PIPEFITTER_CREATE_SUB_SPREAD_CONFIGURATION, payload });
export const pipefitterUpdateSubSpreadConfiguration = (payload) => ({ type: PIPEFITTER_UPDATE_SUB_SPREAD_CONFIGURATION, payload });
export const pipefitterDeleteSubSpreadConfiguration = (payload) => ({ type: PIPEFITTER_DELETE_SUB_SPREAD_CONFIGURATION, payload });
export const pipefitterSortSpreadConfiguration = (payload) => ({ type: PIPEFITTER_SORT_SPREAD_CONFIGURATION, payload });
export const pipefitterSortSubSpreadConfiguration = (payload) => ({ type: PIPEFITTER_SORT_SUB_SPREAD_CONFIGURATION, payload });

// Sequence
export const pipefitterFetchSequenceConfigurationList = (payload) => ({ type: PIPEFITTER_FETCH_SEQUENCE_CONFIGURATION_LIST, payload });
export const pipefitterGenerateSequenceConfigurationList = (payload) => ({ type: PIPEFITTER_GENERATE_SEQUENCE_CONFIGURATION_LIST, payload });
export const pipefitterPipeBasedGenerateSequence = (payload, cb, error) => ({
  type: PIPEFITTER_PIPE_BASED_GENERATE_SEQUENCE,
  payload,
  cb,
  error,
});
export const pipefitterUpdateSpreadName = (payload, cb, err) => ({
  type: PIPEFITTER_UPDATE_SPREAD_NAME,
  payload,
  cb,
  err,
});
export const pipefitterDeleteSequenceSpread = (payload) => ({ type: PIPEFITTER_DELETE_SEQUENCE_SPREAD, payload });
export const pipefitterFetchSequenceReport = (payload) => ({ type: PIPEFITTER_FETCH_SEQUENCE_REPORT, payload });
export const pipefitterApproveSequenceSpread = (payload) => ({ type: PIPEFITTER_APPROVE_SEQUENCE_SPREAD, payload });
export const pipefitterSendEmailSequence = (payload) => ({ type: PIPEFITTER_SEND_EMAIL_SEQUENCE, payload });
export const pipefitterMinMaxCalculation = (payload, cb, error) => ({
  type: PIPEFITTER_MIN_MAX_CALCULATION,
  payload,
  cb,
  error,
});
export const pipefitterSetSequenceList = (payload) => ({ type: PIPEFITTER_SET_SEQUENCE_LIST, payload });
export const pipefitterSetSequenceLoadingMore = (payload) => ({
  type: PIPEFITTER_SET_SEQUENCE_LOADING_MORE,
  payload,
});
export const pipefitterSetSequenceLoading = (payload) => ({ type: PIPEFITTER_SET_SEQUENCE_LOADING, payload });

// Reports
export const pipefitterSetReportsLoading = (payload) => ({ type: PIPEFITTER_SET_REPORTS_LOADING, payload });
export const pipefitterSetPipeStatistics = (payload) => ({ type: PIPEFITTER_SET_PIPE_STATISTICS, payload });
export const pipefitterSetPipeStatus = (payload) => ({ type: PIPEFITTER_SET_PIPE_STATUS, payload });
export const pipefitterSetPipeStatusPagination = (payload) => ({
  type: PIPEFITTER_SET_PIPE_STATUS_PAGINATION,
  payload,
});
export const pipefitterSetPipeStatusLoadingMore = (payload) => ({
  type: PIPEFITTER_SET_PIPE_STATUS_LOADING_MORE,
  payload,
});
export const pipefitterSetPipeDataGraph = (payload) => ({ type: PIPEFITTER_SET_PIPE_DATA_GRAPH, payload });
export const pipefitterSetProjectStatusPipeData = (payload) => ({ type: PIPEFITTER_SET_PROJECT_STATUS_PIPE_DATA, payload });
export const pipefitterSetProjectSummaryData = (payload) => ({ type: PIPEFITTER_SET_PROJECT_SUMMARY_DATA, payload });
export const pipefitterSetPipesListFiltered = (payload) => ({ type: PIPEFITTER_SET_PIPES_LIST_FILTERED, payload });
export const pipefitterFetchPipeDataGraph = (payload) => ({ type: PIPEFITTER_FETCH_PIPE_DATA_GRAPH, payload });
export const pipefitterFetchProjectStatusPipeData = (payload) => ({ type: PIPEFITTER_FETCH_PROJECT_STATUS_PIPE_DATA, payload });
export const pipefitterFetchProjectReport = (payload) => ({ type: PIPEFITTER_FETCH_PROJECT_REPORT, payload });
export const pipefitterFetchProjectSummaryReport = (payload) => ({ type: PIPEFITTER_FETCH_PROJECT_SUMMARY_REPORT, payload });
export const pipefitterSendEmailPipeData = (payload) => ({ type: PIPEFITTER_SEND_EMAIL_PIPE_DATA, payload });
export const pipefitterSendEmailProjectSummary = (payload) => ({ type: PIPEFITTER_SEND_EMAIL_PROJECT_SUMMARY, payload });
export const pipefitterAssignPipeStatusData = (payload) => ({ type: PIPEFITTER_ASSIGN_PIPE_STATUS_DATA, payload });
export const pipefitterCreateUpdatePipeData = (payload, cb, err) => ({
  type: PIPEFITTER_CREATE_UPDATE_PIPE_DATA,
  payload,
  cb,
  err,
});
export const pipefitterDeletePipeData = (payload, cb, err) => ({
  type: PIPEFITTER_DELETE_PIPE_DATA,
  payload,
  cb,
  err,
});
export const pipefitterUpdatePipeStatus = (payload, cb, err) => ({
  type: PIPEFITTER_UPDATE_PIPE_STATUS,
  payload,
  cb,
  err,
});
export const pipefitterGenerateReportPipeData = (payload, cb, err) => ({
  type: PIPEFITTER_GENERATE_REPORT_PIPE_DATA,
  payload,
  cb,
  err,
});
export const pipefitterGenerateReportPipeDataPipewise = (payload, cb, err) => ({
  type: PIPEFITTER_GENERATE_REPORT_PIPE_DATA_PIPEWISE,
  payload,
  cb,
  err,
});
export const pipefitterGenerateReportProjectSummary = (payload, cb, err) => ({
  type: PIPEFITTER_GENERATE_REPORT_PROJECT_SUMMARY,
  payload,
  cb,
  err,
});
export const pipefitterTriggerReportComplimentary = (payload, cb, err) => ({
  type: PIPEFITTER_TRIGGER_REPORT_COMPLIMENTARY,
  payload,
  cb,
  err,
});

// Uploads
export const pipefitterSetInvalidFiles = (payload) => ({ type: PIPEFITTER_SET_INVALID_FILES, payload });
export const pipefitterUploadJsonFiles = (payload) => ({ type: PIPEFITTER_UPLOAD_JSON_FILES, ...payload });

// Random pipe compatibility report
export const pipefitterRandomCompatSubmit = (payload) => ({
  type: PIPEFITTER_RANDOM_COMPAT_SUBMIT,
  payload,
});
export const pipefitterRandomCompatReset = () => ({ type: PIPEFITTER_RANDOM_COMPAT_RESET });
export const pipefitterRandomCompatSetState = (payload) => ({
  type: PIPEFITTER_RANDOM_COMPAT_SET_STATE,
  payload,
});
